import { Col, Row, Spin } from "antd";

export default function SendMessageButton(props) {
  const { handleSendsms, sendBtnLoading, antIcon, dataCy } = props;
  return (
    <Row
      onClick={() => handleSendsms()}
      align={"middle"}
      className="cursor-pointer new-sendsms-icon-wrapper hs-bg-violet hs-fs-14 text-white hs-fw-500"
      data-cy="send-message-button"
    >
      <Col className="d-flex justify-content-center align-items-center" span={10}>
        {sendBtnLoading ? <Spin indicator={antIcon} /> : <div data-cy="inbox-chat-send-btn" className="actionIconsSprite new-sendsms-icon" />}
      </Col>
      <Col span={12}>Send</Col>
    </Row>
  );
}
